/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var VisualEditContrastIcon20Light = forwardRef('VisualEditContrastIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 14.5a5.04 5.04 0 0 1-.5-.025v-9.95a5 5 0 1 1 .5 9.975Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM3 9.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z" })));
});
